import {
  selectVenueScoresByDates,
  selectVenueScoresByMonth,
} from '@/domain/impact-calculate-venue/impact-calculate-venue.selectors';
import { ModelVersionESS } from '@/domain/project/entities/project.entity';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { deleteVenueDate } from '@/domain/project-venue-dates/actions/delete-venue-date.action';
import { editVenueDates } from '@/domain/project-venue-dates/actions/edit-venue-dates.action.ts';
import { selectProjectVenuesDates } from '@/domain/project-venue-dates/project-venue-dates.selectors';
import { useDialogConfirm } from '@/ui/components/confirm-dialog/useDialogConfirm';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { VenueDatesMonthListView } from './VenueDatesMonthListView';

export function ListMonthesView({
  onClickAddDate,
  onClickEditDay,
  onClickEditMonth,
  onClickPresets,
  isSelecting,
  selectedIds,
  onToggleSelect,
  onToggleSelectMonth,
}: {
  onClickAddDate: (month: string) => void;
  onClickEditDay: (
    id: number,
    modelESS: ModelVersionESS,
    scrollTo?: string,
  ) => void;
  onClickEditMonth: (monthDate: string) => void;
  onClickPresets: () => void;
  isSelecting: boolean;
  selectedIds: Set<number>;
  onToggleSelect: (id: number) => void;
  onToggleSelectMonth: (ids: number[], allSelected: boolean) => void;
}) {
  const dialogConfirm = useDialogConfirm();
  const dispatch = useAppDispatch();

  const project = useAppSelector(selectCurrentProjectVenue);
  const venueDates = useAppSelector(selectProjectVenuesDates);
  const scoresByMonth = useAppSelector(
    selectVenueScoresByMonth(project?.id || -1),
  );
  const scoresByDates = useAppSelector(
    selectVenueScoresByDates(project?.id || -1),
  );

  const onSelectPreset = (venueDateId: number, presetId: number) => {
    const venueDate = venueDates.find((d) => d.id === venueDateId);
    if (venueDate?.properties) {
      const args = {
        venueDate: {
          ...venueDate,
          properties: { ...venueDate.properties, presetId },
        },
      };
      dispatch(editVenueDates(args));
    }
  };

  const onClickDelete = async (id: number) => {
    const response = await dialogConfirm({
      title: translate('DeleteVenueDate.Message.confirmation'),
    });
    if (response === 'confirmed') {
      dispatch(deleteVenueDate(id));
    }
  };

  return (
    <VenueDatesMonthListView
      venueDates={venueDates}
      scoresByMonth={scoresByMonth}
      scoresByDates={scoresByDates}
      onClickAdd={onClickAddDate}
      onClickEditDay={onClickEditDay}
      onClickEditMonth={onClickEditMonth}
      onClickDelete={onClickDelete}
      onClickPresets={onClickPresets}
      onSelectPreset={onSelectPreset}
      isSelecting={isSelecting}
      selectedIds={selectedIds}
      onToggleSelect={onToggleSelect}
      onToggleSelectMonth={onToggleSelectMonth}
    />
  );
}
